import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import SignUp from "./pages/Signup/Signup";
import Dashboard from "./pages/Masters/Dashboard/Dashboard";
import AlertPage from "./pages/Masters/Dashboard/AlertPage";
import Test from "./pages/Masters/Dashboard/Test";
import Indent from "./pages/Indent/IndentPage/Indent";
import PEIndent from "./pages/Indent/PE/PEIndent";
import Indent2 from "./pages/Indent/IndentPage/Indent2";
import Indent3 from "./pages/Indent/IndentPage/Indent3";
import L1Indent from "./pages/Indent/L1Page/L1Indent";
import L2Indent from "./pages/Indent/L2Page/L2Indent";
import POIndent from "./pages/Indent/POPage/POIndent";
import PHIndent from "./pages/Indent/PurchaseHead/PHIndent";
import IRIndent from "./pages/Indent/ItemReceived/IRIndent";
import SHIndent from "./pages/Indent/SHPage/SHIndent";
import MItem from "./pages/Masters/MItem/MItem";
import MIndentType from "./pages/Masters/MIndentType/MIndentType";
import MLocation from "./pages/Masters/MLocation/MLocation";
import MStage from "./pages/Masters/MStage/MStage";
import MProject from "./pages/Masters/MProject/MProject";
import Admin from "./pages/Admin/Admin";
import UserRole from "./pages/Admin/UserRole/UserRole";
import MAccount from "./pages/Masters/MAu/mau";
import PrivateRoute from "./components/authentication/PrivateRoute"; // Using PrivateRoute for all protected routes
import MCategory from "./pages/Masters/MCategory/MCategory";
import AddIndent from "./pages/Indent/IndentPage/AddIndent";
import L1Add from "./pages/Indent/L1Page/L1Add";
import L2Add from "./pages/Indent/L2Page/L2Add";
import ViewTable from "./pages/Indent/IndentPage/ItemsPage/ViewTable";
import PeTable from "./pages/Indent/PE/PEViewTable";
import L2Table from "./pages/Indent/L2Page/TL2T";
import L1Table from "./pages/Indent/L1Page/L1Table";
import POTable from "./pages/Indent/POPage/POTable";
import PHTable from "./pages/Indent/PurchaseHead/PHTable";
import IRTable from "./pages/Indent/ItemReceived/IRTable";
import SHTable from "./pages/Indent/SHPage/SHTable";
import IRSH from "./pages/Indent/ItemReceived/IRSH";
import LocationHead from "./pages/Admin/LocationHead/LocationHead";
import ProjectHead from "./pages/Admin/ProjectHead/ProjectHead";
import StoreOfficer from "./pages/Admin/StoreOfficers/StoreOFFicer";
import IndentApproval from "./pages/History/IndentApproval";
import History from "./pages/History/History";
import IndentChange from "./pages/History/IndentItemTracker";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/alerts/:type"
          element={
            <PrivateRoute>
              <AlertPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/test"
          element={
            <PrivateRoute>
              <Test />
            </PrivateRoute>
          }
        />
        <Route
          path="/history/indent_approval"
          element={
            <PrivateRoute>
              <IndentApproval />
            </PrivateRoute>
          }
        />
        <Route
          path="/history/item_track"
          element={
            <PrivateRoute>
              <IndentChange />
            </PrivateRoute>
          }
        />
        <Route
          path="/history"
          element={
            <PrivateRoute>
              <History />
            </PrivateRoute>
          }
        />
        <Route
          path="/indent"
          element={
            <PrivateRoute>
              <Indent />
            </PrivateRoute>
          }
        />
        <Route
          path="/peindent"
          element={
            <PrivateRoute>
              <PEIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/indent2"
          element={
            <PrivateRoute>
              <Indent2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/indent3"
          element={
            <PrivateRoute>
              <Indent3 />
            </PrivateRoute>
          }
        />
        <Route
          path="/L1page"
          element={
            <PrivateRoute>
              <L1Indent />
            </PrivateRoute>
          }
        />
        <Route
          path="/L2page"
          element={
            <PrivateRoute>
              <L2Indent />
            </PrivateRoute>
          }
        />
        <Route
          path="/POpage"
          element={
            <PrivateRoute>
              <POIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/PHpage"
          element={
            <PrivateRoute>
              <PHIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/IRpage"
          element={
            <PrivateRoute>
              <IRIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/SHpage"
          element={
            <PrivateRoute>
              <SHIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/addIndent"
          element={
            <PrivateRoute>
              <AddIndent />
            </PrivateRoute>
          }
        />
        <Route
          path="/addl1Indent"
          element={
            <PrivateRoute>
              <L1Add />
            </PrivateRoute>
          }
        />
        <Route
          path="/addl2Indent"
          element={
            <PrivateRoute>
              <L2Add />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewTable"
          element={
            <PrivateRoute>
              <ViewTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/PETable"
          element={
            <PrivateRoute>
              <PeTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/L1table"
          element={
            <PrivateRoute>
              <L1Table />
            </PrivateRoute>
          }
        />
        <Route
          path="/L2table"
          element={
            <PrivateRoute>
              <L2Table />
            </PrivateRoute>
          }
        />
        <Route
          path="/POtable"
          element={
            <PrivateRoute>
              <POTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/PHtable"
          element={
            <PrivateRoute>
              <PHTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/IRtable"
          element={
            <PrivateRoute>
              <IRTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/IRSHtable"
          element={
            <PrivateRoute>
              <IRSH />
            </PrivateRoute>
          }
        />
        <Route
          path="/SHtable"
          element={
            <PrivateRoute>
              <SHTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/user"
          element={
            <PrivateRoute>
              <UserRole />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/project_head"
          element={
            <PrivateRoute>
              <ProjectHead />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/location_head"
          element={
            <PrivateRoute>
              <LocationHead />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/store_officer"
          element={
            <PrivateRoute>
              <StoreOfficer />
            </PrivateRoute>
          }
        />

        <Route
          path="/mcategory"
          element={
            <PrivateRoute>
              <MCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/mindent_type"
          element={
            <PrivateRoute>
              <MIndentType />
            </PrivateRoute>
          }
        />
        <Route
          path="/mitem"
          element={
            <PrivateRoute>
              <MItem />
            </PrivateRoute>
          }
        />
        <Route
          path="/mlocation"
          element={
            <PrivateRoute>
              <MLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/mstage"
          element={
            <PrivateRoute>
              <MStage />
            </PrivateRoute>
          }
        />
        <Route
          path="/mproject"
          element={
            <PrivateRoute>
              <MProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/mau"
          element={
            <PrivateRoute>
              <MAccount />
            </PrivateRoute>
          }
        />

        {/* Default route */}
        <Route path="/" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
